<template>
  <div class="product-corner-flag">
    <slot />
  </div>
</template>

<script>
  export default {
    name: 'ProductCornerFlag',
  };
</script>

<style lang="scss" scoped>
  .product-corner-flag {
    position: absolute;
    right: -20px;
    top: 20px;
    color: #fff;
    background-color: #65a9d2;
    padding: 2px 18px;
    font-weight: 700;
    border-top-left-radius: 0.25rem;
    border-bottom-left-radius: 0.25rem;
    font-size: 20px;
    box-shadow: -4px -4px 4px rgba(0, 0, 0, 0.25);

    &::after {
      position: absolute;
      top: -20px;
      right: 0;
      content: '';
      height: 20px;
      width: 20px;
      border-bottom: solid 10px #3075a4;
      border-left: solid 10px #3075a4;
      border-right: solid 10px transparent;
      border-top: solid 10px transparent;
    }
  }
</style>
